import { useQuery } from '@tanstack/react-query';
import { Order } from 'types/order';
import { client } from './api-client';

const useGetOrder = (orderRef?: string) =>
  useQuery(
    ['get_order', orderRef],
    () =>
      client<Order>(`/orders/get/${orderRef}`, {
        method: 'get'
      }),
    {
      enabled: !!orderRef
    }
  );

export { useGetOrder };
